import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../../tailwind.config';

const fullConfig = resolveConfig(tailwindConfig);

export const breakpoints = (() => {
  const { screens } = fullConfig.theme;

  Object.entries(screens)
    .forEach(([key, screen]) => {
      screens[key] = Number(screen.slice(0, screen.length - 2));
    });

  return screens;
})();

export const {
  spacing,
} = fullConfig.theme;
